import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import IconButton from './IconButton.js';
import React, {memo} from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {Tooltip} from '@mui/material';
import {string} from 'prop-types';

const CopyButton = memo(({value, title, tooltipPlacement = 'left'}) => {
  return (
    <CopyToClipboard text={value}>
      <Tooltip title={title} placement={tooltipPlacement}>
        <IconButton sx={{cursor: 'pointer'}}>
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </CopyToClipboard>
  );
});

CopyButton.propTypes = {
  title: string,
  value: string.isRequired,
  tooltipPlacement: string,
};

export default CopyButton;
